export default "__VITE_ASSET__CRq_PcM0__"